import { defineMessages } from 'react-intl';

const _default_1: {
	redactionMarker: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	redactionMarker: {
		id: 'editor-extensions.redaction-extension.redaction-marker-aria-label',
		defaultMessage: 'Redacted content. Your organization has removed sensitive data.',
		description:
			'The text is used as the ARIA label for the redaction marker element in the editor, informing screen reader users that sensitive content has been removed by their organization.',
	},
});
export default _default_1;
